import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { Table, DatePicker, Select } from "antd";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import { AuthContext } from "../../context/AuthContext";

dayjs.extend(isBetween);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

export default function ViewImproper() {
    const { authData, backUrl } = useContext(AuthContext);

    const [requests, setRequests] = useState([]);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [filters, setFilters] = useState({
        status: null,
        month: null,
        year: null,
        fromDate: null,
        toDate: null,
    });

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const fetchData = async () => {
        try {
            const res = await axios.get(`${backUrl}/api/hr/regularization/all-requests/`, {
                headers: {
                    Authorization: `Bearer ${authData?.access}`,
                },
            });
            setRequests(res.data.results || res.data);
        } catch (error) {
            console.error("Error fetching regularization requests:", error.response || error.message);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const statusColors = {
        PENDING: "#faad14",
        APPROVED: "green",
        REJECTED: "red",
    };

    const getStatusColor = (status) => {
        if (!status) return "#faad14";
        return statusColors[status.toUpperCase()] || "#faad14";
    };

    const columns = [
        {
            title: "Employee Name",
            dataIndex: "employee_name",
            key: "employee_name",
        },
        // {
        //     title: "Employee Code",
        //     dataIndex: "employee_code",
        //     key: "employee_code",
        // },
        {
            title: "Attendance Date",
            dataIndex: "attendance_date",
            key: "attendance_date",
            render: (val) => (val ? dayjs(val).format("DD/MM/YYYY") : "-"),
        },
        {
            title: "Actual Type",
            key: "type",
            render: (_, record) => (
                (record.first_in_type || record.last_out_type) && (
                    <>
                        {record.first_in_type ? "First In" : "Last Out"}
                    </>
                )
            )
        },
        {
            title: "Actual Mode",
            key: "mode",
            render: (_, record) => (
                (record.first_in_type || record.last_out_type) && (
                    <>
                        {record.first_in_type ? record.actual_first_in_type : record.actual_last_out_type}
                    </>
                )
            )

        },
        {
            title: "Actual Time",
            key: "time",
            render: (_, record) => {
                const value = record.first_in_type
                    ? record.actual_first_in_value
                    : record.actual_last_out_value;

                return value
                    ? dayjs(value).format("DD/MM/YYYY hh:mm A")
                    : "-";
            },
        },
        {
            title: "Updated Type",
            key: "first_in_type",
            render: (_, record) => (
                (record.first_in_type || record.last_out_type) && (
                    <>
                        {record.first_in_type ? "First In" : "Last Out"}
                    </>
                )
            )
        },
        {
            title: "Updated Mode",
            key: "updated_mode",
            render: (_, record) => (
                (record.first_in_type || record.last_out_type) && (
                    <>
                        {record.first_in_type || record.last_out_type}
                    </>
                )
            )
        },
        {
            title: "Updated Time",
            key: "updated_time",
            render: (_, record) => {
                const value = record.first_in_value || record.last_out_value;

                return value
                    ? dayjs(value).format("DD/MM/YYYY hh:mm A")
                    : "-";
            },
        },
        {
            title: "Reason",
            dataIndex: "reason_by_employee",
            key: "reason_by_employee",
            width: 250,
            render: (text) => (
                <div style={{ whiteSpace: "normal", wordWrap: "break-word", maxWidth: "250px" }}>
                    {text || "-"}
                </div>
            ),
        },
        {
            title: "Approver Remarks",
            dataIndex: "remarks_by_approver",
            key: "remarks_by_approver",
            width: 200,
            render: (text) => (
                <div style={{ whiteSpace: "normal", wordWrap: "break-word", maxWidth: "200px" }}>
                    {text || "-"}
                </div>
            ),
        },
        {
            title: "Approved On",
            dataIndex: "approved_on",
            key: "approved_on",
            render: (val) => (val ? dayjs(val).format("DD/MM/YYYY hh:mm A") : "-"),
        },
        {
            title: "Created At",
            dataIndex: "created_at",
            key: "created_at",
            render: (val) => (val ? dayjs(val).format("DD/MM/YYYY hh:mm A") : "-"),
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            render: (text) => (
                <span style={{ fontWeight: 500, color: getStatusColor(text) }}>
                    {text
                        ? text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()
                        : "-"}
                </span>
            ),
        },
    ];

    // Filter Logic
    const filteredData = requests.filter((item) => {
        const date = dayjs(item.attendance_date);

        const matchStatus = filters.status
            ? item.status?.toUpperCase() === filters.status.toUpperCase()
            : true;

        const matchMonth = filters.month ? date.month() + 1 === filters.month : true;
        const matchYear = filters.year ? date.year() === filters.year : true;

        const matchDateRange =
            filters.fromDate && filters.toDate
                ? date.isBetween(filters.fromDate, filters.toDate, "day", "[]")
                : filters.fromDate
                    ? date.isSameOrAfter(filters.fromDate, "day")
                    : filters.toDate
                        ? date.isSameOrBefore(filters.toDate, "day")
                        : true;

        return matchStatus && matchMonth && matchYear && matchDateRange;
    });

    // Extract unique years
    const years = Array.from(
        new Set(requests.map((item) => dayjs(item.attendance_date).year()))
    ).sort((a, b) => b - a);

    return (
        <>
        <center><h4>Inproper Attendance Requests</h4></center>
            {/* Filters */}
            <div
                style={{
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "center",
                    gap: "10px",
                    marginBottom: "16px",
                    flexDirection: isMobile ? "column" : "row",
                    alignItems: "center",
                }}
            >
                <Select
                    placeholder="Filter by Year"
                    style={{ width: isMobile ? "100%" : 140 }}
                    allowClear
                    onChange={(value) => setFilters({ ...filters, year: value })}
                >
                    {years.map((year) => (
                        <Select.Option key={year} value={year}>
                            {year}
                        </Select.Option>
                    ))}
                </Select>

                <Select
                    placeholder="Filter by Month"
                    style={{ width: isMobile ? "100%" : 160 }}
                    allowClear
                    onChange={(value) => setFilters({ ...filters, month: value })}
                >
                    {dayjs.months().map((month, index) => (
                        <Select.Option key={index} value={index + 1}>
                            {month}
                        </Select.Option>
                    ))}
                </Select>

                <DatePicker
                    placeholder="From Date"
                    format="DD/MM/YYYY"
                    style={{ width: isMobile ? "100%" : 160 }}
                    onChange={(date) => setFilters({ ...filters, fromDate: date })}
                />

                <DatePicker
                    placeholder="To Date"
                    format="DD/MM/YYYY"
                    style={{ width: isMobile ? "100%" : 160 }}
                    onChange={(date) => setFilters({ ...filters, toDate: date })}
                />

                <Select
                    placeholder="Status"
                    style={{ width: isMobile ? "100%" : 160 }}
                    allowClear
                    onChange={(value) => setFilters({ ...filters, status: value })}
                >
                    {["PENDING", "APPROVED", "REJECTED"].map((status) => (
                        <Select.Option key={status} value={status}>
                            {status.charAt(0) + status.slice(1).toLowerCase()}
                        </Select.Option>
                    ))}
                </Select>
            </div>

            {/* Table */}
            <Table
                columns={columns}
                dataSource={filteredData.map((item, index) => ({
                    key: index,
                    ...item,
                }))}
                pagination={{ pageSize: 20 }}
                scroll={{ x: true }}
                components={{
                    header: {
                        cell: (props) => (
                            <th
                                {...props}
                                style={{
                                    backgroundColor: "#0e497b",
                                    color: "white",
                                    whiteSpace: "nowrap",
                                }}
                            >
                                {props.children}
                            </th>
                        ),
                    },
                }}
                bordered
            />
        </>
    );
}